import { render, staticRenderFns } from "./paper_edit.vue?vue&type=template&id=861447c8&"
import script from "./paper_edit.vue?vue&type=script&lang=js&"
export * from "./paper_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports